/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';

import { useTranslation } from 'react-i18next';

// icon
import MapIcon from '@material-ui/icons/Map';
import CompareIcon from '@material-ui/icons/Compare';
import VideocamOutlinedIcon from '@material-ui/icons/VideocamOutlined';

// style
// import { globalStyle } from '../../../global/style';
import { styles } from './style';

import ForecastRainfallDataLists from './ForecastRainfallLists/ForecastRainfallDataLists';
import ForecastRainfallAnimationDataLists from './ForecastRainfallLists/ForecastRainfallAnimationDataLists';
import ForecastRainfallCompare from './ForecastRainfallLists/ForecastRainfallCompare';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabContainer = ({ children }) => (
  <Box component="div">
    {children}
  </Box>
);

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `forecast_rain_tab_${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function WaterLeveDatalists() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function List() {
    return (
      <>
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" scrollButtons="auto" aria-label="rainforecasttab">
          <Tab
            label={(
              <>
                <MapIcon />
                <Hidden only="xs"><Box ml={1}>{t('แผนภาพคาดการณ์ฝน ล่วงหน้า 7 วัน')}</Box></Hidden>
                <Hidden lgUp><Box ml={1}>{t('ล่วงหน้า 7 วัน')}</Box></Hidden>
              </>
            )}
            {...a11yProps(0)}
            className={value === 0 ? classes.active_tab : classes.tab}
          />
          <Tab
            label={(
              <>
                <CompareIcon />
                <Hidden only="xs"><Box ml={1}>{t('เปรียบเทียบ แผนภาพคาดการณ์ฝน')}</Box></Hidden>
                <Hidden lgUp><Box ml={1}>{t('เปรียบเทียบ')}</Box></Hidden>
              </>
            )}
            {...a11yProps(1)}
            className={value === 1 ? classes.active_tab : classes.tab}
          />
          <Tab
            label={(
              <>
                <VideocamOutlinedIcon />
                <Box ml={1}>{t('ภาพเคลื่อนไหว')}</Box>
              </>
            )}
            {...a11yProps(2)}
            className={value === 2 ? classes.active_tab : classes.tab}
          />
        </Tabs>
        <Divider />
        <TabContainer component="div">
          <TabPanel value={value} index={0}>
            <ForecastRainfallDataLists />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ForecastRainfallCompare />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <ForecastRainfallAnimationDataLists />
          </TabPanel>
        </TabContainer>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <List />
    </div>
  );
}
